import {ReactElement} from "react"
import {SalesOrder} from "./api/salesorder"
import {PurchaseOrder} from "./api/purchaseorder"
import {WarehouseTransfer} from "./api/warehousetransfer"
import {PlannedSalesReturn} from "./api/plannedsalesreturn"

type Props = {
  item: SalesOrder | PurchaseOrder | WarehouseTransfer | PlannedSalesReturn
  division: number
  long: boolean
}
export default function ExactOnlineLink(
  {item, division, long}: Props
): ReactElement {
  return <a href={item.getExactOnlineUrl(division).toString()}
    target="_blank" rel="noreferrer">
    {long ? (
    item instanceof SalesOrder ? <>
      Sales order {item.orderNumber} ({item.deliverToName}; {item.description})
    </> : item instanceof PurchaseOrder ? <>
      Purchase Order {item.orderNumber} ({item.supplierName}; {item.description})
    </> : item instanceof WarehouseTransfer ? <>
      Warehouse Transfer {item.transferNumber} (
      {item.warehouseFromCode} &#x2192; {item.warehouseToCode}; {item.description})
    </> : <>
      Planned Sales Return {item.returnNumber}
    </>) : (
    item instanceof SalesOrder ? <>
      SO:{item.orderNumber}
    </> : item instanceof PurchaseOrder ? <>
      PO:{item.orderNumber}
    </> : item instanceof WarehouseTransfer ? <>
      WT:{item.transferNumber}
    </> : <>
      PSR:{item.returnNumber}
    </>
    )}
  </a>
}
